import Vue from "vue"
import moment from 'moment'

Vue.filter("numberToKorean", function(num){
    var units = new Array("","일","이","삼","사","오","육","칠","팔","구","십");
    var placeValue = new Array("","십","백","천","","십","백","천","","십","백","천","","십","백","천");
    var korean = "";
    var is_minus = false;
    num=num.toString().replace(/,/g,"");
    if (num.substring(0, 1) === '-') {
        num = num.substring(1, num.length);
        is_minus = true;
    }
    for(var i=0; i<num.length; i++) {
        var str = "";
        var digit = units[num.charAt(num.length-(i+1))];
        if(digit != "")
            str += digit+placeValue[i];
        if(i == 4) str += "만";
        if(i == 8) str += "억";
        if(i == 12) str += "조";
        korean = str + korean;
    }
    if (is_minus) {
        korean = '-' + korean;
    }
    if(num != 0)
        korean = korean + "원정";
    return korean ;
});

/** column formatter 숫자에 콤마를 붙여서 표시 */
Vue.filter('number', function (value) {

    if (value === undefined || value === null) {
        return '';
    }

    value += '';
    if (!value.includes('.')) value += '.';
    return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
        return $1 + ',';
    }).replace(/\.$/, '');

});

Vue.filter('dateTime', function (value) {

    let m = moment(value);
    if (m.isValid()) {
        return m.format('YYYY-MM-DD HH:mm:ss')
    }
    return value;
});

Vue.filter('date', function (value) {

    let m = moment(value);
    if (m.isValid()) {
        return m.format('YYYY-MM-DD')
    }
    return value;

});

Vue.filter('crn', function (value) {

    if (value) {
        let arr1 = value.replace('-', '').split('');
        // arr1 = arr1.map((a, b) => (b === 3 || b === 5) ? '-' + a : a);
        arr1.splice(5, 0, '-');
        arr1.splice(3, 0, '-');
        value = arr1.join('');
    }
    return value;
});

